export default __webpack_public_path__ + "static/media/awsbucket.43ea09de.png";